import { AdhesionInsuredPeopleRequestInterface } from '../../../../interfaces/request/sales-portal/adhesion-insured-people/adhesion-insured-people-request-interface';
import { AdhesionInsuredPeopleModel } from '../../../dto/sales-portal/adhesion-insured-people/adhesion-insured-people-model';

export class AdhesionInsuredPeopleRequestModel implements AdhesionInsuredPeopleRequestInterface {
  insuredPeople: AdhesionInsuredPeopleModel[] = new Array<AdhesionInsuredPeopleModel>();
}
